import Breadcrumbs from "../../components/Common/Breadcrumb"
import React, { useEffect, useState } from "react"
import { Button, Container, Row, Spinner, Table, UncontrolledTooltip } from "reactstrap"
import { withTranslation } from "react-i18next"
import { del, get } from "../../helpers/api_helper"
import { Link } from "react-router-dom"
import { getUserRoleFromToken } from "../../helpers/auth_token_helper"
import { useStore } from "../../contexts/StoreContext"
import { canStorePublishBags } from "../../helpers/store_access_helper"


const Bag = props => {

  const [bags, setBags] = useState([]);
  const [loading, setLoading] = useState(true);
  const role = getUserRoleFromToken();
  const { store } = useStore();
  const canPublishBags = canStorePublishBags(store);

  const fetchBags = async () => {
    const response = await get('bags');
    if (200 === response.status) {
      setBags(response.data["hydra:member"]);
    }
    setLoading(false);
  };

  const onDelete = async (bagId) => {
    if (window.confirm("Voulez-vous vraiment supprimer ce panier ?")) {
      try {
        await del(`bags/${bagId}`);
        setBags(bags.filter(bag => bag.id !== bagId));
      } catch (error) {
        console.error("Erreur lors de la suppression :", error);
      }
    }
  };

  useEffect(() => {
    fetchBags();
  }, []);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Chargement...</span>
        </Spinner>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Gestion des Parniers Suprises")} breadcrumbItem={props.t("Paniers - Gestion et Optimisation")} />

          <div className="card shadow-sm border-0">
            <div className="card-body">
              <p className="text-muted">
                Les <strong>Paniers</strong> vous permettent d’optimiser vos stocks en proposant des produits encore consommables à prix réduit,
                tout en réduisant le gaspillage alimentaire. Cette section vous permet de gérer efficacement vos Paniers.
              </p>

              <div className="list-group mb-3">
                <div className="list-group-item border-0">
                  <i className="bx bx-plus-circle text-success me-2"></i>
                  <strong>Ajoutez un panier</strong> : Remplissez toutes les informations nécessaires et définissez un prix attractif.
                </div>
                <div className="list-group-item border-0">
                  <i className="bx bx-calendar text-info me-2"></i>
                  <strong>Planifiez les collectes</strong> : Indiquez les jours et créneaux horaires où les clients peuvent récupérer leur panier.
                </div>
                <div className="list-group-item border-0">
                  <i className="bx bx-list-check text-warning me-2"></i>
                  <strong>Suivez les réservations</strong> : Consultez en temps réel les paniers réservés et collectés.
                </div>
                <div className="list-group-item border-0">
                  <i className="bx bx-line-chart text-danger me-2"></i>
                  <strong>Analysez vos performances</strong> : Identifiez les paniers les plus populaires et ajustez votre offre en conséquence.
                </div>
              </div>

              <div className="alert alert-light border-start border-primary ps-3">
                <i className="bx bx-bulb text-primary me-2"></i>
                <strong>Astuce</strong> : Plus vos Paniers sont variés et attractifs, plus ils seront rapidement réservés par les clients !
              </div>
            </div>
          </div>

          <div className="mt-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h3 className="text-primary font-size-15">
                <i className="bx bx-package"></i> Liste des Paniers
              </h3>
              {
                canPublishBags && ('admin' === role || 'manager' === role) && (
                  <Link to="/bags/add" className="btn btn-outline-primary">
                    <i className="mdi mdi-plus-circle-outline me-1"></i> Ajouter un panier
                  </Link>
                )
              }
            </div>
            <Table striped bordered hover responsive className="shadow-sm">
              <thead className="table-light">
              <tr>
                <th>Image</th>
                <th>Nom</th>
                <th>Prix (Dhs)</th>
                <th>Prix Réel (Dhs)</th>
                <th>Évaluation</th>
                {
                  ('admin' === role || 'manager' === role) && (
                    <th>Actions</th>
                  )
                }
              </tr>
              </thead>
              <tbody>
              {bags && bags.length > 0 ? (
                bags.map((bag, index) => (
                  <tr key={bag.id}>
                    <td>
                      <img
                      src={bag.image}
                      alt="Aperçu"
                      className="img-thumbnail"
                      style={{ width: "50px", height: "auto" }}
                    />
                    </td>
                    <td>{bag.name}</td>
                    <td>{bag.price}</td>
                    <td>{bag.realPrice}</td>
                    <td>
                      {bag.rating ? `${bag.rating.toFixed(1)} ⭐ (${bag.countRating} avis)` : "Pas encore noté"}
                    </td>
                    {
                      ('admin' === role || 'manager' === role) && (
                      <td className="text-center">
                            <div className="d-flex align-items-center gap-4">
                              <Link to={`/bags/edit/${bag.id}`}>
                                <i className="mdi mdi-pencil font-size-18 text-success" id="edittooltip" />
                                <UncontrolledTooltip placement="top" target="edittooltip">
                                  Modifier
                                </UncontrolledTooltip>
                              </Link>
                              <Link to={'#'} onClick={() => onDelete(bag.id)}>
                                <i className="mdi mdi-delete font-size-18 text-danger" id="deletetooltip" />
                                <UncontrolledTooltip placement="top" target="deletetooltip">
                                  Supprimer
                                </UncontrolledTooltip>
                              </Link>
                            </div>
                      </td>
                      )
                    }
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center text-muted">Aucun panier disponible</td>
                </tr>
              )}
              </tbody>
            </Table>
          </div>

        </Container>
      </div>
    </React.Fragment>
  )
};

export default withTranslation()(Bag);
